$( document ).ready(function() {
   $('.viewMoreBtn').on('click', function () {
    var wrapper = $(this).closest('.description-wrapper');
    var content = wrapper.find('.description-content');
  
    content.toggleClass('expanded');
  
    if (content.hasClass('expanded')) {
      $(this).text('Read Less');
    } else {
      $(this).text('Read More');
    }
  });

  
  
  // Accordain Drawer 

$('.description-drawer-accordian.bold').on('click', function() {
    $('#description-drawer').addClass('open');
    $('.header__wrapper').hide();
  });

  $('#close-description-drawer').on('click', function() {
    $('#description-drawer').removeClass('open');
    setTimeout(function() {
      $('.header__wrapper').show();
    }, 100);
  });

  $(document).on('click', function(e) {
    const $drawer = $('#description-drawer');
    const $toggle = $('.description-drawer-accordian.bold');

    if (
      !$drawer.is(e.target) &&
      $drawer.has(e.target).length === 0 &&
      !$toggle.is(e.target) &&
      $toggle.has(e.target).length === 0
    ) {
      $drawer.removeClass('open');
      setTimeout(function() {
       $('.header__wrapper').show();
      }, 100);
    }
  });

 // Initialize Slick slider
    var backButton = '<span class="slick-prev">&#8592;</span>';
    var nextButton = '<span class="slick-next">&#8594;</span>'
    $('.videos-wrapper').slick({
      slidesToShow: 3,     
      slidesToScroll: 1, 
      autoplay: false,      
      dots: false,      
      arrows: true,        
      infinite: false,      
      speed: 500,
      prevArrow: backButton,
      nextArrow: nextButton,
      draggable: true,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3.1, // Adjust for medium screens
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2.1, // Adjust for smaller screens
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.1, // Adjust for very small screens
          }
        }
      ]
    });


});

  //  **************** Product Button Disabled function


// **************** Variant Selection Popup ****************

// Create the popup HTML (add once to the page)
function createVariantPopup() {
  if (document.getElementById('variant-selection-popup')) return;
  
  const popup = document.createElement('div');
  popup.id = 'variant-selection-popup';
  popup.innerHTML = `
    <div class="variant-popup-overlay"></div>
    <div class="variant-popup-content">
      <button class="variant-popup-close">&times;</button>
      <h3>Please Select Options</h3>
      <p>You must select the following before adding to cart:</p>
      <ul id="variant-popup-list"></ul>
      <button class="variant-popup-btn">Select Options</button>
    </div>
  `;
  document.body.appendChild(popup);
  
  // Close handlers
  popup.querySelector('.variant-popup-close').addEventListener('click', closeVariantPopup);
  popup.querySelector('.variant-popup-overlay').addEventListener('click', closeVariantPopup);
  popup.querySelector('.variant-popup-btn').addEventListener('click', function() {
    closeVariantPopup();
    // Scroll to first unselected option
    const firstUnselected = document.querySelector('.variant-picker__option.unselected');
    if (firstUnselected) {
      firstUnselected.scrollIntoView({ behavior: 'smooth', block: 'center' });
      firstUnselected.querySelector('button.select')?.click();
    }
  });
}

function showVariantPopup(missingOptions) {
  createVariantPopup();
  const list = document.getElementById('variant-popup-list');
  list.innerHTML = missingOptions.map(opt => `<li>${opt}</li>`).join('');
  document.getElementById('variant-selection-popup').classList.add('active');
  document.body.style.overflow = 'hidden';
}

function closeVariantPopup() {
  const popup = document.getElementById('variant-selection-popup');
  if (popup) {
    popup.classList.remove('active');
    document.body.style.overflow = '';
  }
}

// Check for unselected variants and return their names
function getUnselectedVariants($product) {
  var missing = [];
  
  $product.find('.variant-picker__option').each(function() {
    var $option = $(this);
    var selectedText = $option.find('button.select span').text().trim();
    var optionName = $option.find('legend').text().trim().replace(':', '');
    
    if (selectedText === "Please Select") {
      missing.push(optionName);
      $option.addClass('unselected');
    } else {
      $option.removeClass('unselected');
    }
  });
  
  return missing;
}

// Intercept ALL add to cart buttons
$(document).ready(function() {
  createVariantPopup();
  
  // Handle clicks on ANY add to cart button
  $(document).on('click', '[is="custom-button"], .product-info__buy-buttons button[type="submit"], .product-quick-add button', function(e) {
    var $product = $(this).closest('.shopify-section--main-product').length 
      ? $(this).closest('.shopify-section--main-product')
      : $('.product-info').first();
    
    var missingOptions = getUnselectedVariants($product);
    
    if (missingOptions.length > 0) {
      e.preventDefault();
      e.stopPropagation();
      showVariantPopup(missingOptions);
      return false;
    }
  });
});


$(document).ready(function () {
    $('.product-info').each(function () {
        checkSelectedOption($(this));
    });

    $(document).on('change', '.popover-listbox__option input[type="radio"]', function () {
        var $product = $(this).closest('.product-info');
        checkSelectedOption($product);
    });

    $(document).on('click', '.popover-listbox__option input[type="radio"]', function () {
        var $product = $(this).closest('.product-info');
        setTimeout(function(){
            checkSelectedOption($product);
        }, 50);
    });
});
